import type { InspectionCompany, Inspector } from 'api';

import type { SelectedInspector } from '../types';

export const extractInspectorsFromCompanies = (companies: InspectionCompany[]): SelectedInspector[] => {
  return companies.flatMap((company) =>
    company.inspectors.map((inspector: Inspector) => ({
      ...inspector,
      company: company,
    }))
  );
};
